
import { Navbar } from "./navbar"
import { Sidebar } from "./sidebar"
import { Setting } from "./setting"
import { Outlet } from "react-router-dom"
import { useEffect } from "react";

export default function Layout () {

  useEffect(() => {
    const script = document.createElement('script');
  
    script.src = "assets/js/app.js";
    script.async = true;
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    }
  }, []);

  return(
    <>
        <div id="layout-wrapper">
        <Navbar/>
        <Outlet/>
        <Sidebar/>
        </div>
    <Setting/>
    </>
  )

}